/**
 * Server notices as toasts: why a connection was refused, why a dropped
 * module stayed loose.  Each one clears itself after a few seconds.
 */

import { useEffect } from "react";
import { Notification, Stack } from "@mantine/core";
import { IconAlertCircle, IconInfoCircle, IconX } from "@tabler/icons-react";
import { useViewerStore } from "../store";

const LIFETIME_MS = 7000;

export function NoticeToaster() {
  const notices = useViewerStore((state) => state.notices);
  const dismiss = useViewerStore((state) => state.dismissNotice);

  useEffect(() => {
    if (notices.length === 0) return undefined;
    const timers = notices.map((n) => setTimeout(() => dismiss(n.id), Math.max(0, LIFETIME_MS - (Date.now() - n.at))));
    return () => timers.forEach((t) => clearTimeout(t));
  }, [notices, dismiss]);

  if (notices.length === 0) return null;
  return (
    <Stack gap="xs" style={{ position: "fixed", top: 56, right: 16, zIndex: 3000, width: 360, pointerEvents: "none" }}>
      {notices.map((n) => (
        <Notification
          key={n.id}
          style={{ pointerEvents: "auto" }}
          color={n.level === "error" ? "red" : n.level === "info" ? "blue" : "yellow"}
          icon={n.level === "error" ? <IconX size={16} /> : n.level === "info" ? <IconInfoCircle size={16} /> : <IconAlertCircle size={16} />}
          title={n.level === "error" ? "Not done" : n.level === "info" ? "Note" : "Not connected"}
          onClose={() => dismiss(n.id)}
        >
          {n.text}
        </Notification>
      ))}
    </Stack>
  );
}
